export const LOAD_WORKSPACES = 'LOAD_WORKSPACES';
export const CHANGE_WORKSPACE = 'CHANGE_WORKSPACE';
export const SET_CURRENT_APP = 'SET_CURRENT_APP';
export const HANDLE_SERIOUS_ERROR = 'HANDLE_SERIOUS_ERROR';
export const GET_INSTALLED_APPS = 'GET_INSTALLED_APPS';
